import React, { useState } from "react";
import { useParams } from "react-router";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import styled from "styled-components";

import CombinedTrendCard from "./CombinedTrendCard";
import { useTrendsData } from "./hooks/useTrendsData";
import { combineSeries } from "./utils";

const COLOUR_TOTAL = "#c62828";
const COLOUR_4XX = "#ef6c00";
const COLOUR_5XX = "#c62828";

const StyledToggle = styled(ToggleButtonGroup)`
    && .MuiToggleButton-root {
        padding: 4px 14px;
        font-size: 0.75rem;
        text-transform: none;
        border-color: #e5e7eb;
        color: #6b7280;
        border-radius: 8px !important;
    }
    && .MuiToggleButton-root.Mui-selected {
        background-color: #fef2f2;
        color: #c62828;
        font-weight: 600;
    }
    && .MuiToggleButtonGroup-grouped:not(:first-child) {
        margin-left: 6px;
        border-left: 1px solid #e5e7eb !important;
        border-radius: 8px !important;
    }
    && .MuiToggleButtonGroup-grouped:not(:last-child) {
        border-radius: 8px !important;
    }
`;

export default function ErrorsSection({ startDate, endDate }) {
    const { workspaceNumber } = useParams();
    const { series } = useTrendsData({ workspaceNumber, startDate, endDate });

    const s4xx = series((s) => s.statusCodeStats?.http4xxCount ?? 0);
    const s5xx = series((s) => s.statusCodeStats?.http5xxCount ?? 0);
    const totals = combineSeries(s4xx, s5xx);

    const [active, setActive] = useState("totals");

    let chartSeries;
    switch (active) {
        case "4xx":
            chartSeries = [{ label: "4xx errors", series: s4xx, stroke: COLOUR_4XX }];
            break;
        case "5xx":
            chartSeries = [{ label: "5xx errors", series: s5xx, stroke: COLOUR_5XX }];
            break;
        default:
            chartSeries = [{ label: "Total errors (4xx + 5xx)", series: totals, stroke: COLOUR_TOTAL }];
    }

    const tooltip = active === "totals" ? "Total daily errors (4xx + 5xx)." : `Daily ${active} only.`;

    return (
        <CombinedTrendCard
            title="HTTP status — errors"
            tooltip={tooltip}
            startDate={startDate}
            endDate={endDate}
            series={chartSeries}
            remountKey={`errors-${active}-${startDate}-${endDate}`}
        >
            <StyledToggle
                value={active}
                exclusive
                onChange={(_, v) => v && setActive(v)}
                size="small"
            >
                <ToggleButton value="totals">Total</ToggleButton>
                <ToggleButton value="4xx">4xx</ToggleButton>
                <ToggleButton value="5xx">5xx</ToggleButton>
            </StyledToggle>
        </CombinedTrendCard>
    );
}
